/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { TmHttpClient } from '@treasury/core/http';
import { Injectable } from '@treasury/utils/dependency-injection';
import { createSwaggerClient } from '../../utils/tm-swagger-client';

import { HttpClient, RequestParams } from './http-client';

@Injectable()
export class FileClient {
    private readonly http: HttpClient;

    constructor(tmHttp: TmHttpClient) {
        this.http = createSwaggerClient(tmHttp, HttpClient);
    }

    /**
     * No description
     *
     * @tags File
     * @name FileGetFile
     * @summary Gets File in exchange for an ID.
     * @request GET:/File/{id}
     */
    fileGetFile = (id: string, params: RequestParams = {}) =>
        this.http.request<File, File>({
            path: `/File/${id}`,
            method: 'GET',
            format: 'json',
            ...params,
        });
}
